<template>
  <div class="shareholder">
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <div class="formbox">
          <p>网络与信息安全管理组织机构设置及工作职责<span>*</span></p>
        </div>
      </div>
      <div class="formItemRightMain">
        <el-input placeholder="请填写" type="textarea" :rows="2"></el-input>
        <el-popover
          placement="right-start"
          title="标题"
          width="200"
          trigger="hover"
          content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
        >
          <el-button slot="reference"
            ><i class="el-icon-warning"></i
          ></el-button>
        </el-popover>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <div class="formbox">
          <p>网络与信息安全管理人员配备情况及其相应资质<span>*</span></p>
        </div>
      </div>
      <div class="formItemRightMain">
        <el-input placeholder="请填写" type="textarea" :rows="2"></el-input>
        <el-popover
          placement="right-start"
          title="标题"
          width="200"
          trigger="hover"
          content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
        >
          <el-button slot="reference"
            ><i class="el-icon-warning"></i
          ></el-button>
        </el-popover>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>托管协议及托管商IDC证书<span>*</span></p>
      </div>
      <div class="formItemRightUpload">
        <p>
          点击下载《依法经营电信业务承诺书》模板<i class="el-icon-download"></i>
        </p>
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList1"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>身份证<span>*</span></p>
      </div>
      <div class="formItemRightUpload">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList1"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>收费方案<span></span></p>
      </div>
      <div class="formItemRightUpload">
        <p>点击下载《收费方案》模板<i class="el-icon-download"></i></p>
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList1"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <div class="formItemNext">
      <button @click="$router.go(-1)">上一步</button>
      <button>提交</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //图片
      fileList1: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('qffillmaterials/changeActivedIndex', 4);
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>

<style lang="scss">
.shareholder {
  width: 100%;
  background: #fff;
  padding: 4px 0;
  margin-bottom: 60px;
  .applicantInfoFormTitle {
    width: 100%;
    padding-left: 245px;
    padding-top: 20px;
    h1 {
      padding-left: 10px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(38, 38, 38, 1);
      letter-spacing: 1px;
      border-left: 3px solid #fe6a01;
    }
  }
  .applicantInfoFormItem {
    width: 100%;
    display: flex;
    padding: 16px;
    .formItemLeftTitle {
      width: 438px;
      height: 32px;
      .formbox {
        display: flex;
        justify-content: flex-end;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
        padding-right: 10px;
        p {
          width: 154px;
          height: 44px;
          text-align: right;
          span {
            color: #f00;
            margin-left: 5px;
            line-height: 32px;
          }
        }
      }
      & > p {
        text-align: right;
        span {
          color: #f00;
          margin-left: 5px;
          margin-right: 8px;
          line-height: 32px;
        }
      }
    }
    .formItemRightUpload {
      p {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
        margin-bottom: 20px;
        i {
          font-size: 20px;
          margin-left: 5px;
        }
      }

      .el-button {
        width: 100px;
        height: 32px;
        padding: 0;
        border-radius: 4px;
        border: 1px solid rgba(255, 138, 1, 1);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 138, 1, 1);
        line-height: 22px;
        background: #fff;
      }
      .upload-demo {
        width: 435px;
      }
    }
    .formItemRightMain {
      flex: 1;
      display: flex;
      p {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
        margin-bottom: 20px;
        i {
          font-size: 20px;
          margin-left: 5px;
        }
      }
      .el-textarea {
        width: 435px;
        height: 150px;
        textarea {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          color: #ffffff;
        }
      }
      & > span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        margin-left: 10px;
        .el-button {
          width: auto;
          height: auto;
          border: none;
        }
      }
      .el-button {
        width: 100px;
        height: 32px;
        padding: 0;
        border-radius: 4px;
        border: 1px solid rgba(255, 138, 1, 1);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 138, 1, 1);
        line-height: 22px;
        background: #fff;
      }
      .upload-demo {
        width: 435px;
      }
      .appInfomain {
        .inputList {
          width: 100%;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .el-input {
            width: 160px;
            height: 30px;
            margin-right: 10px;
          }
          span {
            display: none;
          }
        }
        .inputList:hover {
          span {
            display: flex;
          }
        }
        .addApp {
          width: 524px;
          height: 28px;
          border-radius: 2px;
          border: 1px dashed rgba(217, 217, 217, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 21px;
          cursor: pointer;
        }
      }
    }
    .formItemRightBt {
      width: 435px;
      height: 32px;
      display: flex;
      flex: none;
      .el-input {
        flex: 1;
      }
      .el-button {
        width: 73px;
        margin-left: 10px;
      }
    }
  }
  .formItemNext {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    button {
      width: 154px;
      height: 36px;
      background: rgba(255, 138, 1, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 22px;
      border: none;
      margin-right: 20px;
      cursor: pointer;
    }
    button:hover {
      opacity: 0.5;
    }
  }
}
</style>
